import React from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

const ROWS = [
  {
    nameKey: "markets.hours.forex.name",
    availKey: "markets.hours.forex.avail",
    descKey: "markets.hours.forex.desc",
    dot: "#22c55e",
  },
  {
    nameKey: "markets.hours.indices.name",
    availKey: "markets.hours.indices.avail",
    descKey: "markets.hours.indices.desc",
    dot: "#22c55e",
  },
  {
    nameKey: "markets.hours.crypto.name",
    availKey: "markets.hours.crypto.avail",
    descKey: "markets.hours.crypto.desc",
    dot: "#4da6ff",
  },
  {
    nameKey: "markets.hours.stocks.name",
    availKey: "markets.hours.stocks.avail",
    descKey: "markets.hours.stocks.desc",
    dot: "#94a3b8",
  },
  {
    nameKey: "markets.hours.commodities.name",
    availKey: "markets.hours.commodities.avail",
    descKey: "markets.hours.commodities.desc",
    dot: "#a8d8f0",
  },
];

function MarketHours() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer">
        <SectionTitle
          title1={t("markets.hours.title1")}
          title2={t("markets.hours.title2")}
          text={t("markets.hours.subtitle")}
          className="mx-auto max-w-[525px]"
        />

        {/* Desktop: таблица */}
        <Fade triggerOnce direction="up" duration={700} className="hidden lg:block mt-[50px]">
        <div className="rounded-[24px] border-[1.5px] border-[#e4edf7] overflow-hidden bg-white">
          <div className="flex items-center bg-[#f8fbff] h-[64px] px-[32px]">
            <p className="w-[240px] font-['Inter'] font-bold text-[16px] text-[#1c385f]">
              {t("markets.hours.col1")}
            </p>
            <p className="w-[340px] font-['Inter'] font-bold text-[16px] text-[#1c385f]">
              {t("markets.hours.col2")}
            </p>
            <p className="flex-1 font-['Inter'] font-bold text-[16px] text-[#1c385f]">
              {t("markets.hours.col3")}
            </p>
          </div>
          {ROWS.map((row, i) => (
            <div
              key={row.nameKey}
              className={`flex items-center h-[72px] px-[32px] border-t border-[#e4edf7] ${
                i % 2 === 1 ? "bg-[#f8fbff]" : "bg-white"
              }`}
            >
              <p className="w-[240px] font-['Inter'] font-bold text-[16px] text-[#1c385f]">
                {t(row.nameKey)}
              </p>
              <div className="w-[340px] flex items-center gap-[10px]">
                <span
                  className="w-[10px] h-[10px] rounded-full shrink-0"
                  style={{ background: row.dot }}
                />
                <p className="font-['Inter'] font-normal text-[16px] text-[#435c7f]">
                  {t(row.availKey)}
                </p>
              </div>
              <p className="flex-1 font-['Inter'] font-normal text-[16px] text-[#435c7f]">
                {t(row.descKey)}
              </p>
            </div>
          ))}
        </div>
        </Fade>

        {/* Mobile / tablet: стопка строк */}
        <div className="lg:hidden mt-[25px] rounded-[20px] border-[1.5px] border-[#e4edf7] overflow-hidden bg-white">
          {ROWS.map((row, i) => (
            <div
              key={row.nameKey}
              className={`px-[20px] py-[20px] ${i > 0 ? "border-t border-[#e4edf7]" : ""} ${
                i % 2 === 1 ? "bg-[#f8fbff]" : "bg-white"
              }`}
            >
              <p className="font-['Inter'] font-bold text-[16px] text-[#1c385f]">
                {t(row.nameKey)}
              </p>
              <div className="mt-[8px] flex items-center gap-[8px]">
                <span
                  className="w-[8px] h-[8px] rounded-full shrink-0"
                  style={{ background: row.dot }}
                />
                <p className="font-['Inter'] font-normal text-[14px] text-[#435c7f]">
                  {t(row.availKey)}
                </p>
              </div>
              <p className="mt-[9px] font-['Inter'] font-normal text-[13px] text-[#435c7f]">
                {t(row.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MarketHours;
